import _ from 'lodash';

function EventDetailCtrl($rootScope, $scope, $timeout, $window, $state, $stateParams, $sce, toastr, AuthService, PlanService, PlayerService, AnalysisService, AppContextService, $ngConfirm, UserService, BioService, BroadcastService, CommonService, DashboardService) {
  'ngInject';

  


  // youtube 검색 API 예제
  // https://codepen.io/linkitapps/pen/eYmGrEN

  var vm = this;
  vm.appContext = AppContextService.context;

  $scope.$on('$destroy', function () {
    sessionStorage.setItem('oppo_team', JSON.stringify(vm.appContext.oppo_team));
  })

  // vm.appContext.players[$stateParams.type_code].my_team.entryMain = [];
  // // vm.appContext.players[$stateParams.type_code].my_team.entryBackup = [];
  // if ($stateParams.type_code === 'game') {
  //   vm.appContext.players[$stateParams.type_code].oppo_team.entryMain = [];
  // }
  // // vm.appContext.players[$stateParams.type_code].oppo_team.entryBackup = [];

  vm.appContext.my_team = {
    team_id: vm.appContext.info.team_id,
    team_name: vm.appContext.info.team_name,
    country_id: vm.appContext.info.country_id,
    country_name: vm.appContext.info.country_name,
  };

  // 전체관리자가 선택한 team_id
  if ($stateParams.manager_admin_team_id) {
    vm.appContext.my_team = vm.appContext.manager_admin_team;
  }

  vm.murl = {};
  vm.murl.url = '';
  vm.murl.title = '';

  vm.training_item = 'ground';

  vm.point = '';

  vm.gname_id = '';
  vm.gtype_id = '';
  vm.lawn_id = '';
  vm.stadium_id = '';
  vm.appContext.oppoTeam_id = '';

  var data = {
    login_id: vm.appContext.user.login_id,
  }

  if ($stateParams.type_code === 'game') {
    data.game_id = $stateParams.id;
    data.oppo_id = vm.appContext.team_id;
  }

  // 선수 개인 코멘트를 저장할 때 줄바꿈이 \n 으로 저장되면 DB 에 저장후 조회할 때 문제가 발생하여
  // 저장할 때 \n 을 '---new line replace---' 으로 치환하고 조회할 때 '---new line replace---' 을 \n 으로 치환
  var newLineFlag = '---new line replace---',
    newLineFlagRe = new RegExp(newLineFlag, 'g');

  // 라이브 경기
  vm.broadcast = {
    list: [],
    set: {
      login_id: vm.appContext.user.login_id,
      id: null,
      name: null,
      url: null,
      game_id: null
    }
  };

  var date, time;

  var setDateTime = function (d) {
    var tzoffset = (new Date(d)).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(new Date(d) - tzoffset)).toISOString().slice(0, -5);
    date = localISOTime.split("T")[0].split("-").join(".");
    time = localISOTime.split("T")[1];
  }

  if (!vm.dateTime) {
    vm.dateTime = new Date();
    setDateTime(vm.dateTime);
  }

  vm.dateTimeChanged = function (dateTime) {
    setDateTime(dateTime._d);
  }

  vm.recommendedVideos = [];

  vm.searchItemName = '';
  vm.isFirstSearch = true;
  var footballArr = ['football', 'football', 'football', 'soccer', 'soccer', 'futsal']; // 검색결과가 다양하게 나오게 하기 위한 처리, football, soccer 에 가중치를 줌

  vm.inputPoint = function (title, item, time) {
    if (!item) {
      toastr.error('항목을 선택하세요.');
      return;
    }

    if ((title === '훈련내용' || title === '워밍업/쿨다운' || title === '코디네이션' || title === '웨이트') && !time) {
      toastr.error('시간을 선택하세요.');
      return;
    }

    vm.point += title + ' : ';
    vm.point += item.name;
    vm.point += time ? ' ' + time + '분' : '';
    vm.point += '\n';

    // 훈련영상 추천
    $('#training-recommend-results').html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">추천 영상을 조회중입니다.</li>');
    var q = (vm.isFirstSearch ? 'football' : footballArr[Math.floor(Math.random() * footballArr.length)]) + ' training ' + item.name;
    var params = {
      q: q,
      part: 'snippet', 
      maxResults: 10
    };
    if (vm.searchItemName === item.name) {  // 같은 훈련내용을 연속해서 입력하는 경우 다른 검색결과를 조회하기 위해 pageToken parameter 설정 예) 훈련내용 공격 입력 후 다시 공격 입력 - https://developers.google.com/youtube/v3/guides/implementation/pagination
      params.pageToken = 'CAoQAA';
    }
    vm.searchItemName = item.name;
    
    PlanService.getVideoRecommend(params)
      .then(function(res) {
        $('#training-recommend-results').empty();
        var srchItems = res.items,
          videos = [];
        $.each(srchItems, function(index, item) {
          if  (item.id.kind === 'youtube#video') {
            videos.push({
              id: item.id.videoId,
              title: item.snippet.title,
              url: 'https://youtube.com/watch?v='  +  item.id.videoId
            });

            var vidThumburl =  item.snippet.thumbnails.default.url;                 
            var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
            var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-id="' + item.id.videoId + '">[영상보기]</a><a href="#" class="select-video" style="margin-left:20px; text-decoration:none; color:#2196F3;" data-url="https://youtube.com/watch?v=' + item.id.videoId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

            $('#training-recommend-results').append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
          }
        });

        vm.recommendedVideos = videos;

        vm.isFirstSearch = false;
      })
      .catch(function(err) {
        console.log(err);
      });
  }

  // 훈련 추천영상 보기
  $('body').off('click.selectVideo').on('click.playVideo', '.play-video', function(e) {
    e.preventDefault();

    var anchor = $(this);

    // 영상목록
    if (anchor.data('kind') === 'playlist') {
      window.open('https://www.youtube.com/playlist?list=' + anchor.data('id'));
    }
    // 영상보기
    else {
      document.getElementById('recommended_video').style.display = 'block';

      $scope.$apply(function () {
        vm.recommendedVideo = _.find(vm.recommendedVideos, {
          id: anchor.data('id')
        });
      });
    }
  });

  // 훈련 추천영상 선택
  $('body').off('click.selectVideo').on('click.selectVideo', '.select-video', function(e) {
    e.preventDefault();

    var anchor = $(this);

    $scope.$apply(function () {
      vm.murl.url = anchor.data('url');
      vm.murl.title = anchor.data('title');
    });

    toastr.success('영상이 선택되었습니다.');
  });

  // 경기 영상 추천
  vm.gameRecommendVideo = function(mode) {
    // 팀명이 National Team 인 경우 팀명 앞에 country_name 을 붙임

    var teamName;
    if (mode === 'my_team') {
      teamName = vm.appContext.my_team.team_name;

      if (vm.appContext.my_team.team_name === 'National Team') {
        teamName = vm.appContext.my_team.country_name + ' ' + teamName;
      }
    } else if (mode === 'oppo_team') {
      teamName = vm.appContext.oppo_team.team_name;

      if (vm.appContext.my_team.team_name === 'National Team') {
        teamName = vm.appContext.oppo_team.country_name + ' ' + teamName;
      }
    }

    if (mode === 'oppo_team' && (!vm.appContext.oppo_team.country_name || !vm.appContext.oppo_team.team_name)) {
      toastr.error('먼저 경기정보에서 상대팀을 선택하세요');
      return;
    }

    $('#game-recommend-results').html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">추천 영상을 조회중입니다.</li>');
    var q = teamName + ' 축구 경기';
    var params = {
      q: q,
      part: 'snippet', 
      maxResults: 10
    };
    if (vm.searchItemName === teamName) {  // 같은  연속해서 입력하는 경우 다른 검색결과를 조회하기 위해 pageToken parameter 설정
      params.pageToken = 'CAoQAA';
    }
    vm.searchItemName = teamName;
    
    PlanService.getVideoRecommend(params)
      .then(function(res) {
        $('#game-recommend-results').empty();
        var srchItems = res.items,
          videos = [];
        $.each(srchItems, function(index, item) {
          if  (item.id.kind === 'youtube#video') {
            videos.push({
              id: item.id.videoId,
              title: item.snippet.title,
              url: 'https://youtube.com/watch?v='  +  item.id.videoId
            });

            var vidThumburl =  item.snippet.thumbnails.default.url;                 
            var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
            var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-id="' + item.id.videoId + '">[영상보기]</a><a href="#" class="select-video" style="margin-left:20px; text-decoration:none; color:#2196F3;" data-url="https://youtube.com/watch?v=' + item.id.videoId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

            $('#game-recommend-results').append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
          }
          // else if (item.id.kind === 'youtube#playlist') {
          //   videos.push({
          //     id: item.id.playlistId,
          //     title: item.snippet.title,
          //     url: 'https://www.youtube.com/playlist?list='  +  item.id.playlistId
          //   });

          //   var vidThumburl =  item.snippet.thumbnails.default.url;                 
          //   var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
          //   var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-kind="playlist" data-id="' + item.id.playlistId + '">[영상목록]</a><a href="#" class="select-video" style="margin-left:20px; text-decoration:none; color:#2196F3;" data-url="https://www.youtube.com/playlist?list='  +  item.id.playlistId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

          //   $('#game-recommend-results').append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
          // }
        });

        vm.recommendedVideos = videos;

        vm.isFirstSearch = false;
      })
      .catch(function(err) {
        console.log(err);
      });
  };

  PlanService.getTrainingMeta()
    .then(function (res) {

      vm.coords = res.data.coords;
      vm.coord = vm.coords[0];
      vm.coord_time = '5';

      vm.equipments = res.data.equipments;
      vm.equipment = vm.equipments[0];

      vm.movements = res.data.movements;
      vm.movement = vm.movements[0];
      vm.movement_time = '5';

      vm.plans = res.data.plans;
      vm.plan = vm.plans[0];

      vm.targets = res.data.targets;
      vm.target = vm.targets[0];

      vm.wcs = res.data.wcs;
      vm.wc = vm.wcs[0];
      vm.wc_time = '5';

      vm.weights = res.data.weights;
      vm.weight = vm.weights[0];
      vm.weight_time = '5';

    })
    .catch(function (error) {
      console.log('ERROR ' + error);
    });

  var getGameInfo = function () {

    vm.appContext.oppo_team = null;

    UserService.getCountries().then(function (res) {
      var data = res.data;
      vm.stadiumContinents = data.list;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

    PlanService.getStadiums()
      .then(function (res) {
        vm.parent_stadiums = res.data.list;

        var data = {
          login_id: vm.appContext.user.login_id,
          uuid: vm.appContext.user.uuid,
          [$stateParams.type_code + '_id']: $stateParams.id,
        };

        // 전체관리자가 선택한 team_id
        if ($stateParams.manager_admin_team_id) {
          data.team_id = $stateParams.manager_admin_team_id;
        }

        PlanService.getGameInfo(data)
          .then(function (res) {

            console.log('game_info', res.data)

            vm.date = res.data.date;

            if (res.data.gtype_id) {
              if (res.data.first_start)  first_start.setDate(new Date(new Date().toISOString().substr(0, 10) + ' ' + res.data.first_start));
              if (res.data.first_end)    first_end.setDate(new Date(new Date().toISOString().substr(0, 10) + ' ' + res.data.first_end));
              if (res.data.second_start) second_start.setDate(new Date(new Date().toISOString().substr(0, 10) + ' ' + res.data.second_start));
              if (res.data.second_end)   second_end.setDate(new Date(new Date().toISOString().substr(0, 10) + ' ' + res.data.second_end));

              if (res.data.extra_first_start)  { extra_first_start.setDate(new Date(new Date().toISOString().substr(0, 10) + ' ' + res.data.extra_first_start)); }
              if (res.data.extra_first_end)    extra_first_end.setDate(new Date(new Date().toISOString().substr(0, 10) + ' ' + res.data.extra_first_end));
              if (res.data.extra_second_start) extra_second_start.setDate(new Date(new Date().toISOString().substr(0, 10) + ' ' + res.data.extra_second_start));
              if (res.data.extra_second_end)   extra_second_end.setDate(new Date(new Date().toISOString().substr(0, 10) + ' ' + res.data.extra_second_end));
              
              // vm.first_end_mo = res.data.first_end ? moment(res.data.first_end, "hh:mm:ss") : null;
              // vm.second_start_mo = res.data.second_start ? moment(res.data.second_start, "hh:mm:ss") : null;
              // vm.second_end_mo = res.data.second_end ? moment(res.data.second_end, "hh:mm:ss") : null;
              // vm.extra_first_start_mo = res.data.extra_first_start ? moment(res.data.extra_first_start, "hh:mm:ss") : null;
              // vm.extra_first_end_mo = res.data.extra_first_end ? moment(res.data.extra_first_end, "hh:mm:ss") : null;
              // vm.extra_second_start_mo = res.data.extra_second_start ? moment(res.data.extra_second_start, "hh:mm:ss") : null;
              // vm.extra_second_end_mo = res.data.extra_second_end ? moment(res.data.extra_second_end, "hh:mm:ss") : null;

              vm.team_name = res.data.team_name;
              vm.team_id = res.data.team_id;
              vm.country_name = res.data.country_name;

              vm.appContext.oppo_team = {
                team_id: res.data.team_id,
                team_name: res.data.team_name,
                country_id: res.data.country_id,
                country_name: res.data.country_name,
              }

              vm.gtypes = res.data.gtypes;
              vm.gtype_id = res.data.gtype_id;
              vm.parent_gnames = res.data.parent_gnames;
              vm.parent_gname_id = res.data.parent_gname_id;
              vm.gnames = res.data.gnames;
              vm.gname_id = res.data.gname_id;

              vm.parent_stadiums = res.data.parent_stadiums;
              $timeout(function () { // $watch 로 vm.stadiumCountry 의 변화에 따라 vm.stadius 목록을 만드는 부분이 있어서 vm.stadium 설정이 안되어, 약간의 시간 지연을 둠
                vm.parent_stadium = vm.parent_stadiums[_.findIndex(vm.parent_stadiums, {
                  id: res.data.parent_stadium_id
                })];
              }, 2000);

              vm.stadiums = res.data.stadiums;
              $timeout(function () {
                vm.stadium = vm.stadiums[_.findIndex(vm.stadiums, {
                  id: res.data.stadium_id
                })];
              }, 3000);

              vm.referee = res.data.referee;
              vm.subreferee = res.data.subreferee;
              vm.linesman1 = res.data.linesman1;
              vm.linesman2 = res.data.linesman2;

              vm.weather = res.data.weather;
              vm.temperature = res.data.temperature;
              vm.humidity = res.data.humidity;
              vm.wind = res.data.wind;
              vm.altitude = res.data.altitude;
              vm.pm10 = res.data.dirt;
              vm.pm25 = res.data.super_dirt;

              vm.lawn_id = Number(res.data.lawn_id);


              var continentId = res.data.stadium_parent_country_id,
                countryId = res.data.stadium_country_id;

              vm.stadiumContinent = _.find(vm.stadiumContinents, {
                id: continentId
              });

              UserService.getCountries({
                parent_id: continentId
              }).then(function (res) {
                vm.stadiumCountries = res.data.list;

                vm.stadiumCountry = _.find(vm.stadiumCountries, {
                  id: countryId
                });
              });
            }

          })
          .catch(function (error) {
            console.log('ERROR ' + error);
          });

        PlanService.getGameResult(data)
          .then(function (res) {
            vm.result = res.data;
          })
          .catch(function (error) {
            console.log('ERROR ' + error);
          });
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });
  }

  var getBroadcastList = function() {
    BroadcastService.list({
      login_id: vm.broadcast.set.login_id
    }).then(function(data) {
      vm.broadcast.list = data.list;
      if (data.list.length > 0) {
        vm.broadcast.set.id = vm.broadcast.list[0].id;
        vm.broadcast.set.name = vm.broadcast.list[0].name;
        vm.broadcast.set.url = vm.broadcast.list[0].url;
      }
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  };

  if ($stateParams.type_code === 'game') {
    getGameInfo();
    getBroadcastList();
  }

  vm.setTrainingInfo = function () {

    if (!vm.target) {
      toastr.error('훈련목표를 선택하세요.');
      return;
    }
    if (!vm.plan) {
      toastr.error('훈련계획을 선택하세요.');
      return;
    }
    if (!vm.movement) {
      toastr.error('훈련내용을 선택하세요.');
      return;
    }
    if (!vm.movement_time) {
      toastr.error('훈련내용시간을 선택하세요.');
      return;
    }
    if (!vm.wc) {
      toastr.error('워밍업/쿨다운을 선택하세요.');
      return;
    }
    if (!vm.wc_time) {
      toastr.error('워밍업/쿨다운시간을 선택하세요.');
      return;
    }
    if (!vm.weight) {
      toastr.error('웨이트을 선택하세요.');
      return;
    }
    if (!vm.weight_time) {
      toastr.error('웨이트시간을 선택하세요.');
      return;
    }
    if (!vm.coord) {
      toastr.error('코디네이션을 선택하세요.');
      return;
    }
    if (!vm.coord_time) {
      toastr.error('코디네이션시간을 선택하세요.');
      return;
    }
    if (!vm.equipment) {
      toastr.error('장비를 선택하세요.');
      return;
    }
    if (!vm.stadium) {
      toastr.error('운동장을 선택하세요.');
      return;
    }
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      // [$stateParams.type_code + '_id']: $stateParams.id,
      training_root_id: $stateParams.id,

      target_id: vm.target && vm.target.id,
      plan_id: vm.plan && vm.plan.id,
      movement_id: vm.movement && vm.movement.id,
      movement_time: vm.movement_time,
      wc_id: vm.wc && vm.wc.id,
      wc_time: vm.wc_time,
      weight_id: vm.weight && vm.weight.id,
      weight_time: vm.weight_time,
      coord_id: vm.coord && vm.coord.id,
      coord_time: vm.coord_time,
      equipment_id: vm.equipment && vm.equipment.id,
      parent_stadium_id: vm.parent_stadium && vm.parent_stadium.id,
      stadium_id: vm.stadium && vm.stadium.id,
      point: vm.point,
      weather: vm.weather,
      humidity: vm.humidity,
      temperature: vm.temperature,
      wind: vm.wind,
      altitude: vm.altitude,
      lawn_id: vm.lawn_id,
      dirt: vm.pm10 || '',
      super_dirt: vm.pm25 || ''
    };
    _.omit(data, _.isUndefined)

    // 선수인 경우에는 team_comment 를 저장하지 않음
    if (vm.appContext.user.user_type_id !== '1') {
      data.team_comment = vm.team_comment;
    }

    // 선수 코멘트
    vm.loginPlayerComment = null;
    if (vm.comment_players && vm.comment_players.length) {
      var arr = [];
      _.forEach(vm.comment_players, function(item) {
        arr.push(item.user_id + '::' + item.name + '::' + item.comment);

        if (item.user_id == vm.appContext.user.user_id) {
          vm.loginPlayerComment = item.user_id + '::' + item.name + '::' + item.comment;
        }
      });

      data.person_comment = arr.join('||');
    }

    // 훈련정보 저장
    // 선수가 아닌 경우
    if (vm.appContext.user.user_type_id !== '1') {
      PlanService.setTraining(data)
        .then(function (data) {
          // getTrainingInfo();
          toastr.success('저장되었습니다.');
        })
        .catch(function (error) {
          console.log('ERROR ' + error);
        });
    }
    // 선수인 경우에는 person_comment 를 불러온 후 저장
    else {
      var loginPlayerCommentAdded = false;
      PlanService.getTraining(vm.getTrainingParams)
          .then(function (res) {

            var personComment = res.data.person_comment,
              arr = [],
              newPersonComment = '';

            if (vm.loginPlayerComment) {
              if (personComment) {
                var temp = personComment.split('||');
                _.forEach(temp, function(item) {
                  var temp2 = item.split('::');
                  if (temp2[0] == vm.appContext.user.user_id) {   // 로그인한 선수의 코멘트
                    arr.push(vm.loginPlayerComment);
                    loginPlayerCommentAdded = true;
                  } else {
                    arr.push(item);
                  }
                });

                // 로그인한 선수의 코멘트가 있으나 위에서 저장(수정)되지 않은 경우
                if (!loginPlayerCommentAdded) {
                  arr.push(vm.loginPlayerComment);
                }

                newPersonComment = arr.join('||');
              } else {
                newPersonComment = vm.loginPlayerComment;
              }

              newPersonComment = newPersonComment.replace(/\n/g, newLineFlag);
              data.person_comment = newPersonComment;
            }
            
            // 훈련 정보 저장
            PlanService.setTraining(data)
              .then(function (data) {
                // getTrainingInfo();
                toastr.success('저장되었습니다.');
              })
              .catch(function (error) {
                console.log('ERROR ' + error);
              });

          })
          .catch(function (error) {
            console.log('ERROR ' + error);

            // 훈련 정보 저장 - 훈련 최초 생성한 후 처음 저장할 때에는 PlanService.getTraining 으로 훈련을 불러올 수 없어서 여기에서 저장
            console.log('data', data);
            PlanService.setTraining(data)
              .then(function (data) {
                // getTrainingInfo();
                toastr.success('저장되었습니다.');
              })
              .catch(function (error) {
                console.log('ERROR ' + error);
              });
          });
    }

    // 라이브 훈련 URL 저장
    vm.broadcast.set.name = vm.appContext.info.team_name;
    vm.broadcast.set.training_root_id = $stateParams.id;
    // vm.broadcast.set.url 이 있으면 추가
    if (vm.broadcast.set.url) {
      // vm.broadcast.set.id 가 있는 경우에는 수정, 없는 경우에는 추가
      BroadcastService.set(vm.broadcast.set)
        .then(function() {
          console.log('broadcast', vm.broadcast);
        }).catch(function (e) {
          console.log('ERROR ' + e);
        });
    }
    // vm.broadcast.set.url 이 없으면 삭제
    else {
      if (vm.broadcast.set.id) {
        BroadcastService.remove({
          login_id: vm.broadcast.set.login_id,
          id: vm.broadcast.set.id
        });
      }
    }
  }

  // 훈련정보 불러오기 parameter
  vm.getTrainingParams = null;

  var getTrainingInfo = function () {

    UserService.getCountries().then(function (res) {
      var data = res.data;
      vm.stadiumContinents = data.list;
    });

    PlanService.getStadiums()
      .then(function (res) {
        vm.parent_stadiums = res.data.list;
        var data = {
          login_id: vm.appContext.user.login_id,
          uuid: vm.appContext.user.uuid,
          training_root_id: $stateParams.id,
        };

        // 전체관리자가 선택한 team_id
        if ($stateParams.manager_admin_team_id) {
          data.team_id = $stateParams.manager_admin_team_id;
        }

        vm.getTrainingParams = data;

        PlanService.getTraining(data)
          .then(function (res) {

            vm.date = res.data.date;

            if (res.data.target_id) {
              vm.target = vm.targets[_.findIndex(vm.targets, {
                id: res.data.target_id
              })];
              vm.plan = vm.plans[_.findIndex(vm.plans, {
                id: res.data.plan_id
              })];
              vm.movement = vm.movements[_.findIndex(vm.movements, {
                id: res.data.movement_id
              })];
              vm.movement_time = res.data.movement_time.toString();
              vm.wc = vm.wcs[_.findIndex(vm.wcs, {
                id: res.data.wc_id
              })];
              vm.wc_time = res.data.wc_time.toString();
              vm.weight = vm.weights[_.findIndex(vm.weights, {
                id: res.data.weight_id
              })];
              vm.weight_time = res.data.weight_time.toString();
              vm.coord = vm.coords[_.findIndex(vm.coords, {
                id: res.data.coord_id
              })];
              vm.coord_time = res.data.coord_time.toString();
              vm.equipment = vm.equipments[_.findIndex(vm.equipments, {
                id: res.data.equipment_id
              })];
              vm.parent_stadiums = res.data.parent_stadiums;
              $timeout(function () { // $watch 로 vm.stadiumCountry 의 변화에 따라 vm.stadius 목록을 만드는 부분이 있어서 vm.stadium 설정이 안되어, 약간의 시간 지연을 둠
                vm.parent_stadium = vm.parent_stadiums[_.findIndex(res.data.parent_stadiums, {
                  id: res.data.parent_stadium_id
                })];
              }, 2000);
              vm.stadiums = res.data.stadiums;
              $timeout(function () {
                vm.stadium = vm.stadiums[_.findIndex(res.data.stadiums, {
                  id: res.data.stadium_id
                })];
              }, 3000);
              vm.point = res.data.point;
              vm.team_comment = res.data.team_comment;

              vm.weather = res.data.weather;
              vm.temperature = res.data.temperature;
              vm.humidity = res.data.humidity;
              vm.wind = res.data.wind;
              vm.altitude = res.data.altitude;
              vm.pm10 = res.data.dirt;
              vm.pm25 = res.data.super_dirt;

              vm.lawn_id = Number(res.data.lawn_id);

              var continentId = res.data.stadium_parent_country_id,
                countryId = res.data.stadium_country_id;

              vm.stadiumContinent = _.find(vm.stadiumContinents, {
                id: continentId
              });

              vm.trainingPersonComment = res.data.person_comment;

              UserService.getCountries({
                parent_id: continentId
              }).then(function (res) {
                vm.stadiumCountries = res.data.list;

                vm.stadiumCountry = _.find(vm.stadiumCountries, {
                  id: countryId
                });
              });
            }

          })
          .catch(function (error) {
            console.log('ERROR ' + error);
          });
      })
      .catch(function (error) {
        console.log('ERROR ' + error);
      });
  }

  if ($stateParams.type_code === 'training') {
    getTrainingInfo();
  }

  vm.setGemeResult = function () {

    var dataResult = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      [$stateParams.type_code + '_id']: $stateParams.id,
      goals: vm.result.goals,
      lost_points: vm.result.lost_points,
      assists: vm.result.assists,
      fouls: vm.result.fouls,
      warnings: vm.result.warnings,
      sending_offs: vm.result.sending_offs,
      good_deed: vm.result.good_deed,
      imp_point: vm.result.imp_point,
      person_comment: vm.result.person_comment
    }

    // 선수인 경우에는 team_comment 를 저장하지 않음
    if (vm.appContext.user.user_type_id !== '1') {
      dataResult.team_comment = vm.result.team_comment;
    }

    _.omit(dataResult, _.isUndefined)

    if (!vm.team_id) {
      toastr.error('경기정보를 먼저 저장하세요.');
      return;
    }

    // if (!dataResult.team_comment) {
    //   toastr.error('경기코멘트를 입력하세요.');
    //   return;
    // }

    PlanService.setGameResult(dataResult)
      .then(function (res) {
        toastr.success('경기결과를 저장했습니다.');
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
  }

  vm.setGameInfo = function () {

    if (!vm.team_id) {
      toastr.error('상대팀을 선택하세요.');
      return;
    }

    if (!vm.gtype_id) {
      toastr.error('경기구분을 선택하세요.');
      return;
    }
    if (vm.gtype_id == 1 && !vm.gname_id) {   // 실전경기인 경우에만
      toastr.error('경기명칭을 선택하세요.');
      return;
    }
    if (!vm.stadium) {
      toastr.error('경기장을 선택하세요.');
      return;
    }
    if (!vm.lawn_id) {
      toastr.error('경기장 잔디상태를 선택하세요.');
      return;
    }

    // 선수 코멘트
    if (vm.comment_players && vm.comment_players.length) {
      var arr = [];
      _.forEach(vm.comment_players, function(item) {
        arr.push(item.user_id + '::' + item.name + '::' + item.comment);
      });

      vm.result.person_comment = arr.join('||');
    }

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      [$stateParams.type_code + '_id']: $stateParams.id,

      first_start: $('#first_start').val(),
      first_end: $('#first_end').val(),
      second_start: $('#second_start').val(),
      second_end: $('#second_end').val(),
      extra_first_start: $('#extra_first_start').val(),
      extra_first_end: $('#extra_first_end').val(),
      extra_second_start: $('#extra_second_start').val(),
      extra_second_end: $('#extra_second_end').val(),
      // extra_first_start: '',
      // extra_first_end: '',
      // extra_second_start: '',
      // extra_second_end: '',

      // first_end: vm.first_end_mo ? moment(vm.first_end_mo).format("HH:mm:ss") : '',
      // second_start: vm.second_start_mo ? moment(vm.second_start_mo).format("HH:mm:ss") : '',
      // second_end: vm.second_end_mo ? moment(vm.second_end_mo).format("HH:mm:ss") : '',
      // extra_first_start: vm.extra_first_start_mo ? moment(vm.extra_first_start_mo).format("HH:mm:ss") : '',
      // extra_first_end: vm.extra_first_end_mo ? moment(vm.extra_first_end_mo).format("HH:mm:ss") : '',
      // extra_second_start: vm.extra_second_start_mo ? moment(vm.extra_second_start_mo).format("HH:mm:ss") : '',
      // extra_second_end: vm.extra_second_end_mo ? moment(vm.extra_second_end_mo).format("HH:mm:ss") : '',
      progress_time: vm.progress_time,
      gtype_id: vm.gtype_id,
      gname_id: vm.gname_id,
      team_id: vm.team_id,
      stadium_id: vm.stadium.id,
      weather: vm.weather,
      humidity: vm.humidity,
      temperature: vm.temperature,
      wind: vm.wind,
      altitude: vm.altitude,
      lawn_id: vm.lawn_id,
      referee: vm.referee,
      subreferee: vm.subreferee,
      linesman1: vm.linesman1,
      linesman2: vm.linesman2,
      goals: vm.result.goals,
      lost_points: vm.result.lost_points,
      assists: vm.result.assists,
      fouls: vm.result.fouls,
      warnings: vm.result.warnings,
      sending_offs: vm.result.sending_offs,
      good_deed: vm.result.good_deed,
      imp_point: vm.result.imp_point,
      person_comment: vm.result.person_comment,
      dirt: vm.pm10 || '',
      super_dirt: vm.pm25 || ''
    };

    // 선수인 경우에는 team_comment 를 저장하지 않음
    if (vm.appContext.user.user_type_id !== '1') {
      data.team_comment = vm.result.team_comment;
    }

    _.omit(data, _.isUndefined)

    PlanService.setGameInfo(data)
      .then(function (res) {
        toastr.success('저장했습니다.');
        getGameInfo();
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });

    // 라이브 경기 URL 저장
    vm.broadcast.set.name = vm.appContext.info.team_name +' ' + vm.result.goals + ' VS ' + vm.result.lost_points + ' ' + vm.team_name;
    vm.broadcast.set.game_id = $stateParams.id;
    // vm.broadcast.set.url 이 있으면 추가
    if (vm.broadcast.set.url) {
      // vm.broadcast.set.id 가 있는 경우에는 수정, 없는 경우에는 추가
      BroadcastService.set(vm.broadcast.set)
        .then(function() {
          console.log('broadcast', vm.broadcast);
        }).catch(function (e) {
          console.log('ERROR ' + e);
        });
    }
    // vm.broadcast.set.url 이 없으면 삭제
    else {
      if (vm.broadcast.set.id) {
        BroadcastService.remove({
          login_id: vm.broadcast.set.login_id,
          id: vm.broadcast.set.id
        });
      }
    }
  }

  vm.setDisplayPosition = function () {

    // 축구장을 비우고 새로 셋팅 한다.
    $("#player-main-field-position").empty();

    // 포지션별 div를 셋팅 한다.
    _.forEach(vm.playerPositionClass, function (pos) {
      $("#player-main-field-position").append('<div class="pos-wrapper ' + pos + '"></div>');
    });

    _.forEach(vm.selectPlayerListPosition, function (player) {
      var targetObj = vm.teamBioDataList[player.user_id];
      var pos = targetObj.position;

      var targetDivs = $('.' + pos);
      var cssKey = 'margin-left';

      targetDivs.append('<span><strong>' + targetObj.back_number + '</strong>' + targetObj.name + '</span>');
      if (pos == 'FW-RWF' || pos == 'MF-RWM' || pos == 'MF-RM' || pos == 'DF-RWB' || pos == 'DF-RB') {
        cssKey = 'margin-right';
      }

      targetDivs.css(cssKey, (parseInt(targetDivs.css(cssKey)) - 30) + 'px');
    });

  };

  // 동영상 생성/수정
  vm.setMurl = function () {
    if (!vm.murl.url) {
      toastr.error('동영상 URL을 입력해주십시오');
      return;
    }
    if (!vm.murl.title) {
      toastr.error('동영상 제목을 입력해주십시오');
      return;
    }
    // if (!vm.user_id) {
    //   toastr.error('선수를 선택해주십시오');

    //   return;
    // }

  
    var user_id = '';

    if ($stateParams.type_code === 'game') {
      var arr = vm.appContext.players[$stateParams.type_code].my_team.entryMain
        .concat(vm.appContext.players[$stateParams.type_code].my_team.entryBackup);
    } else {
      var arr = vm.appContext.players[$stateParams.type_code].my_team.entryMain;      
    }

    user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
    if (!user_id) {
      user_id = _.map(vm.appContext.players.all, 'user_id').join();
    }



    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      [$stateParams.type_code + '_id']: $stateParams.id,
      user_id: user_id,
      url: vm.murl.url,
      subtitle: vm.movement.name,
      title: vm.murl.title
    };

    // console.log('data', data);
    // return;


    PlanService.setMurl(data)
      .then(function (res) {
        toastr.success('저장되었습니다.');
        getMurls();
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
  };

  var getMurls = function () {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      [$stateParams.type_code + '_id']: $stateParams.id,
    };

    PlanService.getMurls(data)
      .then(function (res) {
        _.forEach(res.data.murls, function (video) {
          if (video.url.indexOf('?v=') > -1) {
            video.image = 'https://img.youtube.com/vi/' + video.url.split('=')[1] + '/0.jpg';
          } else {
            video.image = 'https://img.youtube.com/vi/' + video.url.substring((video.url).lastIndexOf('/') + 1) + '/0.jpg';
          }
        });

        vm.videos = res.data.murls;
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });
  }
  getMurls();

  //동영상 삭제
  vm.removeMurl = function (id) {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      murl_id: id
    };

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            PlanService.removeMurl(data)
              .then(function (res) {
                toastr.success('삭제되었습니다.')
                getMurls();
              })
              .catch(function (error) {
                console.log("An error occured : " + error);
              });
          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  }

  vm.remove = function (id) {
    vm.gameRemovePasswd = null;

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      content: '삭제하시겠습니까? <input type="password" ng-model="vm.gameRemovePasswd" placeholder="비밀번호를 입력하세요">',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {
            var data = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              passwd: vm.gameRemovePasswd
            }
            if ($stateParams.type_code === 'game') {
              data.game_id = id;
              PlanService.removeGame(data)
                .then(function () {
                  $state.go('Service.event', {
                    type_code: $stateParams.type_code,
                    type_name: $stateParams.type_name,
                    year: $stateParams.year,
                    month: $stateParams.month
                  });
                })
                .catch(function (error) {
                  console.log("An error occured : " + error);
                });

            } else {
              data.training_root_id = id;
              PlanService.removeTraining(data)
                .then(function () {
                  $state.go('Service.event', {
                    type_code: $stateParams.type_code,
                    type_name: $stateParams.type_name,
                    year: $stateParams.year,
                    month: $stateParams.month
                  });
                })
                .catch(function (error) {
                  console.log("An error occured : " + error);
                });

            }

            // 동영상이 있는 경우 삭제
            if (vm.videos && vm.videos.length) {
              _.forEach(vm.videos, function(item) {
                PlanService.removeMurl({
                  login_id: vm.appContext.user.login_id,
                  uuid: vm.appContext.user.uuid,
                  murl_id: item.id
                })
                  .then(function (res) {
                    
                  })
                  .catch(function (error) {
                    console.log("An error occured : " + error);
                  });
              });
            }
          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  }

  PlanService.getGameMeta()
    .then(function (res) {
      vm.gtypes = res.data.gtypes;
      vm.lawns = res.data.lawns;
    })
    .catch(function (error) {
      console.log("An error occured : " + error);
    });

  PlanService.getGnames()
    .then(function (res) {
      vm.parent_gnames = res.data.list;
    })
    .catch(function (error) {
      console.log("An error occured : " + error);
    });

  var isMyTeamLoaded = false;
  var isOppoTeamLoaded = false;

  var getPattern = function (team, isFirst) {
    // return;
    // console.log('getPattern....', team, $stateParams.type_code )
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
    };

    // 전체관리자가 선택한 team_id
    if ($stateParams.manager_admin_team_id) {
      data.team_id = $stateParams.manager_admin_team_id;
    }

    // data.user_id = '';
    var arr = [];
    if (team === 'my_team' && $stateParams.type_code === 'game') {
      if (!isMyTeamLoaded) {
        if (!vm.appContext.players.game.my_team.entryMain ||
          !vm.appContext.players.game.my_team.entryBackup) {
          return;
        }
        arr = vm.appContext.players.game.my_team.entryMain
          .concat(vm.appContext.players.game.my_team.entryBackup)
        data.user_id = _.map(arr, 'user_id').join();

        isMyTeamLoaded = true;

      } else {
        arr = vm.appContext.players.game.my_team.entryMain
          .concat(vm.appContext.players.game.my_team.entryBackup)
        data.user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
        vm.user_ids = _.map(_.filter(arr, 'selected'), 'user_id');
      }
    }

    if (team === 'my_team' && $stateParams.type_code === 'training') {
      if (!isMyTeamLoaded) {
        if (!vm.appContext.players.training.my_team.entryMain) {
          return;
        }
        arr = vm.appContext.players.training.my_team.entryMain;
        data.user_id = _.map(arr, 'user_id').join();

        isMyTeamLoaded = true;

      } else {
        arr = vm.appContext.players.training.my_team.entryMain;
        data.user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
        vm.user_ids = _.map(_.filter(arr, 'selected'), 'user_id');
      }
    }

    if (team === 'oppo_team' && $stateParams.type_code === 'game') {
      if (!isOppoTeamLoaded) {
        if (!vm.appContext.players.game.oppo_team.entryMain ||
          !vm.appContext.players.game.oppo_team.entryBackup) {
          return;
        }
        arr = vm.appContext.players.game.oppo_team.entryMain
          .concat(vm.appContext.players.game.oppo_team.entryBackup)
        data.user_id = _.map(arr, 'user_id').join();

        isOppoTeamLoaded = true;

      } else {
        arr = vm.appContext.players.game.oppo_team.entryMain
          .concat(vm.appContext.players.game.oppo_team.entryBackup)
        data.user_id = _.map(_.filter(arr, 'selected'), 'user_id').join();
        vm.user_ids = _.map(_.filter(arr, 'selected'), 'user_id');

      }
    }

    if (vm.appContext.role2 === 'player') {
      // console.log('player', vm.appContext)
      data.user_id = vm.appContext.user.user_id;
      console.log('player', data.user_id, team, data.user_id)

    }

    vm.user_id = data.user_id;
    console.log('vm.user_id', vm.user_id, data.user_id)


    if (team === 'my_team') {
      vm.injuryAll = [];

      vm.injuryPatterns = [];
      vm.my_team_patterns = [];
      vm.bioPatterns = [];
      vm.rank = null;
    } else {
      vm.oppo_team_patterns = [];
    }


    if ($stateParams.type_code == 'game') {
      data.game_id = $stateParams.id;
      PlanService.getGameResult(data)
        .then(function (res) {
          console.log('111')
          if (res.data.summary) {
            vm.rank = res.data.summary[0];
          } else {
            vm.rank = res.data.per_user_data[0];
          }
        })
        .catch(function (error) {
          console.log('ERROR ' + error);
        });
    }

    AnalysisService.patterns(data)
      .then(function (res) {
        if (team === 'my_team') {
          vm.my_team_patterns = res.data.summary;
        } else {
          vm.oppo_team_patterns = res.data.summary;
        }
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });

    BioService.patterns(data)
      .then(function (res) {
        vm.bioPatterns = res.data.summary;
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      });

    AnalysisService.injuryPatterns(data)
      .then(function (res) {
        vm.injuryPatterns = res.data.patterns;
        var data = res.data.user_data;
        vm.injuryAll = [];
        for (var i = 0; i < data.length; i++) {
          var patterns = data[i].patterns;
          for (var j = 0; j < patterns.length; j++) {
            patterns[j].user_id = data[i].user_id;
            patterns[j].user_name = data[i].user_name;
            vm.injuryAll.push(patterns[j])
          }
        }
      })
      .catch(function (error) {
        console.log('ERROR ' + error);
      });
  }

  $scope.$watch('vm.appContext.players.' + $stateParams.type_code + '.my_team.entryMain', function (newVal, oldVal) {
    if (newVal) {
      getPattern('my_team', false);
    }
  }, true)
  $scope.$watch('vm.appContext.players.' + $stateParams.type_code + '.my_team.entryBackup', function (newVal, oldVal) {
    if (newVal) {
      getPattern('my_team', false);
    }
  }, true)



  $scope.$watch('vm.appContext.players.' + $stateParams.type_code + '.oppo_team.entryMain', function (newVal, oldVal) {
    if (newVal) {
      getPattern('oppo_team', false);
    }
  }, true)
  $scope.$watch('vm.appContext.players.' + $stateParams.type_code + '.oppo_team.entryBackup', function (newVal, oldVal) {
    if (newVal) {
      getPattern('oppo_team', false);
    }
  }, true)



  $scope.$watch('vm.parent_gname_id', function (newVal, oldVal) {
    if (newVal) {
      PlanService.getGnames({
        parent_id: newVal
      }).then(function (res) {
        vm.gnames = res.data.list;
      }).catch(function (e) {
        console.log('ERROR', e);
      });
    }
  });

  // 경기장 대륙 변경
  $scope.$watch('vm.stadiumContinent', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.stadiumCountries = res.data.list;

        vm.parent_stadiums = null;
        vm.stadiums = null;

        vm.stadiumCountry = vm.stadiumCountries[0];
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 경기장 국가 변경
  $scope.$watch('vm.stadiumCountry', function (newVal, oldVal) {
    if (newVal) {
      PlanService.getStadiums({
        country_id: newVal.id
      }).then(function (res) {
        vm.parent_stadiums = res.data.list;

        vm.stadiums = null;

        vm.parent_stadium = vm.parent_stadiums[0];
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  $scope.$watch('vm.parent_stadium', function (newVal, oldVal) {
    // if (newVal && vm.stadium_id) {
    if (newVal) {
      PlanService.getStadiums({
        country_id: vm.stadiumCountry.id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.stadiums = res.data.list;

        vm.stadium = vm.stadiums[0];
      }).catch(function (e) {
        console.log('ERROR', e);
      });
    }
  });

  vm.parent_gname_changed = function (item) {
    PlanService.getStadiums({
      parent_id: vm.parent_stadium.id
    }).then(function (res) {
      vm.stadiums = res.data.list;
    }).catch(function (e) {
      console.log('ERROR', e);
    });
  }

  $scope.$watch('vm.stadium', function (newVal, oldVal) {
    if (newVal) {
      getWeather();
    }
  });

  var getWeather = function () {

    var address = vm.parent_stadium.name + ' ' + vm.stadium.name;
    let lat;
    let lng;
    // 지오코딩
    PlanService.geocode(address).then(function (data) {
      if (data.results && data.results.length) {
        lat = data.results[0].geometry.location.lat;
        lng = data.results[0].geometry.location.lng;

        let gridObj = PlanService.dfsXyConv('toXY', lat, lng);

        // 기상청 날씨정보 가져오기
        PlanService.getWeather(gridObj.nx, gridObj.ny).then(function (data) {
          let items = data.response.body.items.item;

          // 하늘상태(날씨)
          let sky = _.find(items, {
            category: 'SKY'
          });

          if (sky && !vm.weather) {
            if (sky.obsrValue == 1) {
              vm.weather = '맑음';
            } else if (sky.obsrValue == 2) {
              vm.weather = '구름조금';
            } else if (sky.obsrValue == 3) {
              vm.weather = '구름많음';
            } else if (sky.obsrValue == 4) {
              vm.weather = '흐림';
            }
          }

          // 습도
          let reh = _.find(items, {
            category: 'REH'
          });
          if (reh && !vm.humidity) {
            vm.humidity = reh.obsrValue;
          }

          // 기온
          let t1h = _.find(items, {
            category: 'T1H'
          });
          if (t1h && !vm.temperature) {
            vm.temperature = t1h.obsrValue;
          }

          // 풍속(바람)
          let wsd = _.find(items, {
            category: 'WSD'
          });
          if (wsd && !vm.wind) {
            vm.wind = wsd.obsrValue;
          }
        }).catch(function (e) {
          console.log('ERROR ' + e);
        });

        // 미세먼지 정보 가져오기
        PlanService.getFineDust(vm.parent_stadium.name).then(function(data) {
        // PlanService.getFineDust('강원').then(function (data) {
          let findDustData = data.list[0];

          if (findDustData.pm10Value && !vm.pm10) {
            vm.pm10 = findDustData.pm10Value;
          }
          if (findDustData.pm25Value && !vm.pm25) {
            vm.pm25 = findDustData.pm25Value;
          }
        }).catch(function (e) {
          console.log('ERROR ' + e);
        });
      }
    });
  };

  UserService.getCountries()
    .then(function (res) {
      vm.continents = res.data.list;
    })
    .catch(function (error) {
      console.log("An error occured : " + error);
    });


  // 대륙 변경
  $scope.$watch('vm.continent', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.countries = res.data.list;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  var country_id;
  // 국가 변경
  $scope.$watch('vm.country', function (newVal, oldVal) {
    if (newVal) {
      // 초기 팀 목록 불러오기
      country_id = newVal.id;
      UserService.getTeams({
        country_id: newVal.id
      }).then(function (res) {
        vm.teams1 = res.data.list;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 팀 1단계 변경
  $scope.$watch('vm.selectedTeam1', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getTeams({
        country_id: country_id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.teams2 = res.data.list
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    } else {}
  });

  // 팀 2단계 변경
  $scope.$watch('vm.selectedTeam2', function (newVal, oldVal) {
    vm.selectedTeam3 = null;
    vm.selectedTeam4 = null;
    if (newVal && !newVal.is_last) {
      UserService.getTeams({
        country_id: country_id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.teams3 = res.data.list;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    } else {
      vm.teams3 = null;
    }
  });

  // 팀 3단계 변경
  $scope.$watch('vm.selectedTeam3', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getTeams({
        country_id: country_id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.teams4 = res.data.list;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    } else {
      vm.teams4 = null;
    }
  });

  $scope.$watch('vm.selectedTeam4', function (newVal, oldVal) {
    if (newVal) {
      vm.team_id = newVal.id;

      // appContext 에 상대팀 정보 저장
      vm.appContext.oppo_team = {
        team_id: newVal.id,
        team_name: newVal.name,
        country_id: vm.country.id,
        country_name: vm.country.name,
      }
    }
  });

  $scope.$watch('vm.team_id', function (newVal, oldVal) {
    if (newVal) {
      vm.appContext.team_id = newVal;
    }
  });


  // 경기, 훈련 컨텐츠 관리 시작
  vm.contents = [];
  vm.content = {};
  var contentsList = function () {
    var data = {
      login_id: vm.appContext.user.login_id,
    };
    DashboardService.list(data)
    .then(function (res) {
      var contents = _.find(res.data.lists, {
        type: $stateParams.type_name
      });
      if (contents) {
        contents = contents.list[0].contents;
      }
      vm.contents = contents;
    })
    .catch(function(error) {
      console.log('ERROR : ',  error);
    });
  }
  contentsList();

  vm.setContent = function (type) {

    if (!vm.content.subtitle) {
      toastr.error('구분을 선택해 주세요. ')
      return;
    }

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      type: type, // game, training
      is_video: 'N',
      is_admin: 'N',
      title: vm.content.title,
      subtitle: vm.content.subtitle,
      url: vm.content.url
    };

    if (!data.title) {
      toastr.error('제목을 입력하세요');
      return;
    }

    if (!data.subtitle) {
      toastr.error('구분을 선택하세요');
      return;
    }

    if (!data.url) {
      toastr.error('url을 입력하세요');
      return;
    }


    DashboardService.set(data).then(function (res) {
      contentsList();
    });
  }

  vm.removeContent = function (id) {

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var data = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              id: id
            };
            DashboardService.remove(data).then(function (res) {
              contentsList();
            }).catch(function (e) {
              console.log('ERROR ' + e);
            });


          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
          // action: function (scope, button) {
          // }
        },
      }
    });


  };
  // 경기, 훈련 컨텐츠 관리 끝

  vm.comment_players = [];
  // 경기 - 선수에게 comment 보내기 시작
  $scope.$watch('vm.result', function(newVal, oldVal) {
    if (newVal) {
      vm.comment_players = [];
      var temp = newVal.person_comment.split('||');

      if (temp && temp[0]) {
        _.forEach(temp, function(item) {
          var temp2 = item.split('::');
          vm.comment_players.push({
            user_id: +temp2[0],
            name: temp2[1],
            comment: temp2[2]
          });
        });
      }
    }

    // 선수로 로그인한 경우 자신의 코멘트 칸 생성
    if (vm.appContext.user.user_type_id === '1' && !(_.find(vm.comment_players, {user_id: +vm.appContext.user.user_id}))) {
      vm.comment_players.push({
        user_id: +vm.appContext.user.user_id,
        name: vm.appContext.user.name,
        comment: ''
      });
    }
  });

  $scope.$watch('vm.user_ids', function (newVal, oldVal) {
    _.forEach(newVal, function(item) {
      var obj = _.find(vm.comment_players, {
        user_id: item
      });

      if (!obj) {
        var obj2 = _.find(vm.appContext.players[$stateParams.type_code].my_team.entryMain, {
          user_id: item
        });
        if (!obj2) {
          obj2 = _.find(vm.appContext.players[$stateParams.type_code].my_team.entryBackup, {
            user_id: item
          });
        }

        vm.comment_players.push({
          user_id: obj2.user_id,
          name: obj2.name,
          comment: obj2.comment
        });
      }

      console.log(vm.comment_players);
    });
  });
  // 경기 - 선수에게 comment 보내기 끝

  // 훈련 - 선수에게 comment 보내기 시작
  $scope.$watch('vm.trainingPersonComment', function(newVal, oldVal) {
    if (newVal) {
      vm.comment_players = [];
      var temp = newVal.split('||');

      if (temp && temp[0]) {
        _.forEach(temp, function(item) {
          var temp2 = item.split('::');
          vm.comment_players.push({
            user_id: +temp2[0],
            name: temp2[1],
            comment: temp2[2].replace(newLineFlagRe, '\n')
          });
        });
      }
    }

    // 선수로 로그인한 경우 자신의 코멘트 칸 생성
    if (vm.appContext.user.user_type_id === '1' && !(_.find(vm.comment_players, {user_id: +vm.appContext.user.user_id}))) {
      vm.comment_players.push({
        user_id: +vm.appContext.user.user_id,
        name: vm.appContext.user.name,
        comment: ''
      });
    }
  });

  $scope.$watch('vm.user_ids', function (newVal, oldVal) {
    _.forEach(newVal, function(item) {
      var obj = _.find(vm.comment_players, {
        user_id: item
      });

      if (!obj) {
        var obj2 = _.find(vm.appContext.players[$stateParams.type_code].my_team.entryMain, {
          user_id: item
        });
        if (!obj2) {
          obj2 = _.find(vm.appContext.players[$stateParams.type_code].my_team.entryBackup, {
            user_id: item
          });
        }

        vm.comment_players.push({
          user_id: obj2.user_id,
          name: obj2.name,
          comment: obj2.comment
        });
      }

      console.log(vm.comment_players);
    });
  });
  // 훈련 - 선수에게 comment 보내기 끝

  vm.trustAsHtml = function(value) {
    return $sce.trustAsHtml(value);
  };


  let config = {
    time_24hr: true,
    minuteIncrement: 1,
    noCalendar: true,
    enableTime: true,
    enableSeconds: true,
    dateFormat: "H:i:S",
    onOpen: [
      function (selectedDates, dateStr, instance) {
        if (!dateStr) {
          instance.setDate(new Date());
        }
      },
    ],
  };

  let first_start = null; 
  let first_end = null; 
  let second_start = null;
  let second_end = null; 
  let extra_first_start = null;
  let extra_first_end = null;
  let extra_second_start = null;
  let extra_second_end = null; 

  $scope.$on('$viewContentLoaded', function () {
    first_start = flatpickr("#first_start", config);
    first_end = flatpickr("#first_end", config);
    second_start = flatpickr("#second_start", config);
    second_end = flatpickr("#second_end", config);

    extra_first_start = flatpickr("#extra_first_start", config);
    extra_first_end = flatpickr("#extra_first_end", config);
    extra_second_start = flatpickr("#extra_second_start", config);
    extra_second_end = flatpickr("#extra_second_end", config);
  });

  $scope.$on('youtube.player.ready', function ($event, player) {
    $rootScope.YTPlayer = player;
  });

}

export default {
  name: 'EventDetailCtrl',
  fn: EventDetailCtrl
};
